import React, { useEffect } from "react";
import PDFViewer from "../components/PDFViewer";
import { useParams } from "react-router-dom";

const ReportPreview = () => {
    const { reportId } = useParams();
    const [pdfData, setPdfData] = React.useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await this.Server.generateReport(reportId);
                const data = await res.blob();
                setPdfData(URL.createObjectURL(data));
            } catch (error) {
                console.error("An error occurred while fetching the PDF:", error);
            }
        };
        fetchData();
    }, [reportId]);

    return <PDFViewer pdfData={pdfData} />;
};

export default ReportPreview;
